import React from "react";
import styled from "styled-components";
import { ReactComponent as SearchIconSvg } from "@/assets/result/search_icon.svg?react";
import { designTokens, getTypography } from "styles/designTokens";

const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;

  svg {
    position: absolute;
    left: 16px;
    width: 16px;
    height: 16px;
  }
`;

const StyledInput = styled.input`
  flex: 1;
  display: flex;
  gap: 4px;
  padding: 8px 16px;
  padding-left: 36px;
  border: 1px solid ${designTokens.colors.line.button};
  border-radius: 6px;
  font-size: ${getTypography("korean", "body3").fontSize};
  font-weight: ${getTypography("korean", "body3").fontWeight};
  line-height: ${getTypography("korean", "body3").lineHeight};
  letter-spacing: ${getTypography("korean", "body3").letterSpacing};

  &::placeholder {
    color: ${designTokens.colors.font.quinary};
  }
`;

const SearchIcon = styled(SearchIconSvg)`
  path {
    fill: ${designTokens.colors.font.tertiary};
  }
`;

interface SearchInputProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
}) => {
  return (
    <SearchInputWrapper>
      <SearchIcon />
      <StyledInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </SearchInputWrapper>
  );
};

export default SearchInput;
